/* "Shown from Help" (APP-090): the words that go with the ring, so it isn't colour alone. */
.tag {
  flex: none;
}

/* On the top edge of a box with no heading row, clear of what's inside it. */
.edge {
  position: absolute;
  top: 0;
  right: 16px;
  z-index: 1;
  transform: translateY(-50%);
  /* Words only: a click, and the space a control needs, pass through to what it sits over. */
  pointer-events: none;
}
